import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useState } from 'react';

import { fetchPortalSubscriptionPlans } from '../services/portalSubscriptionPlans.api';
import type { PortalBillingPeriod } from '../types/portalPlans';
import { filterPlansByBillingCycle } from '../utils/portalPlanHelpers';

export function usePortalSubscriptionPlans(enabled = true) {
  const [billingPeriod, setBillingPeriod] = useState<PortalBillingPeriod | null>(null);

  const query = useQuery({
    queryKey: ['customer', 'subscription', 'plans'],
    queryFn: fetchPortalSubscriptionPlans,
    enabled,
  });

  useEffect(() => {
    if (!query.data || billingPeriod !== null) return;
    setBillingPeriod(query.data.default_billing_period);
  }, [query.data, billingPeriod]);

  const visiblePlans = useMemo(() => {
    if (!query.data || billingPeriod === null) return [];
    return filterPlansByBillingCycle(query.data.plans, billingPeriod);
  }, [query.data, billingPeriod]);

  const availableBillingPeriods = query.data?.billing_periods ?? [];
  const availableCurrencies = query.data?.available_currencies ?? [];

  return {
    ...query,
    billingPeriod,
    setBillingPeriod,
    visiblePlans,
    availableBillingPeriods,
    availableCurrencies,
  };
}
